;(() => {
  const arRelatedUnicodes = /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF]/

  function getTextDirection(str) {
    if (typeof str == "string" && arRelatedUnicodes.test(str)) {
      return "rtl"
    }

    return "ltr"
  }

  window.HB ??= {}
  window.HB.getTextDirection = getTextDirection
})()
